export default "__VITE_ASSET__vSlYoesh__"